<template>
  <div id="user-profile">
    <div class="filter-area" :class="filterVisible ? 'visible' : 'hidden'">
      <filter-wrapper
        :configuration="configuration"
        :applied-filters="filtersApplied"
        :filter-visible="filterVisible"
        @handleFilterChange="handleFilterChange($event)"
        @handleSearchChange="handleSearchChange($event)"
        @handleFilterToggle="handleFilterToggle($event)"
        @toggleFilter="toggleFilter"
        @onClearFilter="onClearFilter" />
    </div>
    <div class="content-area" :class="[cardType === 'list' && 'scrollable']">
      <div class="title-area">
        <h1 class="title">User Management</h1>
        <div class="filter-button" @click="toggleFilter">
          <span>Filter</span>
          <div>
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="inherit"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.48032 6.55747H7.13293C7.41687 7.65343 8.40547 8.46875 9.58902 8.46875C10.7726 8.46875 11.7612 7.65343 12.0451 6.55747H20.5188C20.8691 6.55747 21.1534 6.27321 21.1534 5.92285C21.1534 5.57249 20.8691 5.28824 20.5188 5.28824H12.0451C11.7612 4.19227 10.7726 3.37695 9.58902 3.37695C8.40547 3.37695 7.41687 4.19227 7.13293 5.28824H1.48032C1.12996 5.28824 0.845703 5.57249 0.845703 5.92285C0.845703 6.27321 1.12996 6.55747 1.48032 6.55747ZM9.58902 4.64618C10.293 4.64618 10.8657 5.21883 10.8657 5.92285C10.8657 6.62688 10.293 7.19952 9.58902 7.19952C8.88499 7.19952 8.31235 6.62688 8.31235 5.92285C8.31235 5.21883 8.88499 4.64618 9.58902 4.64618Z"
                fill="inherit" />
              <path
                d="M20.5188 10.3654H19.1597C18.8758 9.26942 17.8872 8.4541 16.7036 8.4541C15.5201 8.4541 14.5315 9.26942 14.2476 10.3654H1.48032C1.12996 10.3654 0.845703 10.6496 0.845703 11C0.845703 11.3504 1.12996 11.6346 1.48032 11.6346H14.2476C14.5315 12.7306 15.5201 13.5459 16.7036 13.5459C17.8872 13.5459 18.8758 12.7306 19.1597 11.6346H20.5188C20.8691 11.6346 21.1534 11.3504 21.1534 11C21.1534 10.6496 20.8691 10.3654 20.5188 10.3654ZM16.7036 12.2767C15.9996 12.2767 15.427 11.704 15.427 11C15.427 10.296 15.9996 9.72333 16.7036 9.72333C17.4077 9.72333 17.9803 10.296 17.9803 11C17.9803 11.704 17.4077 12.2767 16.7036 12.2767Z"
                fill="inherit" />
              <path
                d="M20.5188 15.442H8.22259C7.9387 14.3461 6.95016 13.5308 5.76728 13.5308C4.58373 13.5308 3.59513 14.3461 3.31119 15.442H1.48032C1.12996 15.442 0.845703 15.7263 0.845703 16.0767C0.845703 16.427 1.12996 16.7113 1.48032 16.7113H3.31119C3.59513 17.8072 4.58373 18.6226 5.76728 18.6226C6.95016 18.6226 7.9387 17.8072 8.22259 16.7113H20.5188C20.8691 16.7113 21.1534 16.427 21.1534 16.0767C21.1534 15.7263 20.8691 15.442 20.5188 15.442ZM5.76728 17.3533C5.06325 17.3533 4.49061 16.7807 4.49061 16.0767C4.49061 15.3726 5.06325 14.8 5.76728 14.8C6.47048 14.8 7.04312 15.3726 7.04312 16.0767C7.04312 16.7807 6.47048 17.3533 5.76728 17.3533Z"
                fill="inherit" />
            </svg>
          </div>
        </div>
      </div>
      <filter-tags
        v-if="!filterCleared"
        :content="appliedFiltersByRole"
        @onRemoveFilter="onRemoveFilter($event)"
        @onClearFilter="onClearFilter" />
      <div class="actions-container">
        <textbox
          placeholder="Enter your search term..."
          icon="search"
          inputclass="search-box" />
        <div class="btn-container">
          <custom-button
            class="add-user-button"
            variant="primary"
            title="Add User"
            icon="addUser"
            :disabled="!getIsSupport"
            @onClick="handleAddUser"></custom-button>
        </div>
      </div>
      <h4 v-if="userError" class="error-message">
        Unable to fetch data, please try again by refreshing the page, if issue
        still persist kindly try any of the following method
        <ul>
          <li>Clear your browser cache</li>
          <li>Try in private window(Incognito)</li>
        </ul>
      </h4>
      <h4 v-else-if="userLoading" class="error-message">
        <dashboard-skeleton />
      </h4>
      <div v-else-if="usersListCount" class="grid-cards">
        <approvers-table
          :items="usersList"
          :user-has-not-access="userHasNotAccess"
          :employee-id="user.employeeId"
          @handleActionChange="handleActionChange($event, $data)"
          @handleEditUser="handleEditUser"
          @handleDeleteUser="handlePreDeleteUser"></approvers-table>
      </div>
      <div v-else class="approver-management-empty-state">
        <img
          alt="No result found"
          src="https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoibWFlcnNrXC9hY2NvdW50c1wvYmNcLzQwMDAxNDdcL3Byb2plY3RzXC8xMDdcL2Fzc2V0c1wvOGFcLzI1Mzc3XC84ZWQ3YzMwZWY2ZWU2M2Y2NWQ5YzYzNGZkYTVmZWMzYS0xNjAwODM2Njk0LnN2ZyJ9:maersk:pkaGBou0OgP5QfzjjC7Ib5HWKNyRyzfUugSXyKvXs3c?width=800" />
        <h4>No Result Found</h4>
      </div>
      <pagination
        :total-items="usersListCount"
        :current-page="activePage"
        :page-size="itemsPerPage"
        :page-count="pageCount"
        :on-page-change="onChangePage" />
    </div>
    <approver-modal
      v-if="addModalOpen"
      header="Add New User"
      submit-btn-text="Create User"
      name="add-user-modal"
      @onModalClose="handleApproverModalClose"
      @onSubmit="handleCreateUser" />
    <approver-modal
      v-if="editModalOpen"
      header="Edit User: "
      submit-btn-text="Save User"
      name="edit-user-modal"
      :edit-data="editModalData"
      edit-history
      @onModalClose="handleEditApproverModalClose"
      @onSubmit="handleUpdateUser" />
    <confirmation-modal
      v-if="deleteConfirmModalOpen"
      :header="`Delete User: ${deleteApprover.userName}`"
      message="Are you sure want to delete?"
      submit-btn-text="Delete"
      cancel-btn-text="Cancel"
      @onConfirm="handleDeleteUser"
      @onModalClose="
        onDeleteConfirmModalClose('confirmation-modal')
      "></confirmation-modal>
  </div>
</template>
  <script>
// Actions
import { userManagament, userActions } from "@/actions";

// Utilities
import AxiosFetch from "@/utils/axios";
import { getFilterStatus } from "@/utils/helpers";

// Components
import { CustomButton } from "@/components/common";

// Maersk Design System Components
import { FilterTags } from "@/components/common";

import Pagination from "@/components/common/Pagination/Pagination.vue";
import FilterWrapper from "@/components/FilterWrapper/FilterWrapper.vue";
import {
  ApproversTable,
  ApproverModal,
  ConfirmationModal,
} from "@/components/ApproverManagement";
import DashboardSkeleton from "@/components/Skeleton/DashboardSkeleton";

// Configs
import { UserFiltersConfig } from "@/config/userFilterConfig";
import {
  isEmpty,
  getMsalIdToken,
  isObject,
  scrollWindow,
} from "@/utils/helpers";
import { showToast } from "@/components/common/Toast";

// Constants
import {
  azureActiveDirectoryGroups,
  approverManagementConstants,
} from "@/config/constant";
import { mapGetters } from "vuex";
import { sumIterate } from "xe-utils/methods";

export default {
  name: "ApproverManagement",
  components: {
    DashboardSkeleton,
    ApproversTable,
    CustomButton,
    ApproverModal,
    ConfirmationModal,
    FilterWrapper,
    FilterTags,
    Pagination,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    skipTour: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    const storedFilters = sessionStorage.getItem(
      "userApproverAppliedFilters_v1.1.9"
    );

    const filtersAppliedFromStorage = storedFilters
      ? JSON.parse(storedFilters)
      : {};

    return {
      activePage: 1,
      itemsPerPage: 30,
      cardType: "list",
      userError: false,
      userLoading: true,
      usersList: [],
      usersListCount: 0,
      actionData: {},
      selectedStatus: null,
      configuration: UserFiltersConfig,
      allconfiguration: UserFiltersConfig,
      initialcheckboxdata: "",
      triggerUpdate: new Date(),
      filterVisible: false,
      filterCleared: false,
      isAdditionalInfoModalOpen: false,
      additionalInfoData: [],
      actionModalOpen: false,
      isActionLoading: false,
      showDashboardTour: false,
      userOptions: {
        useKeyboardNavigation: true,
        labels: {
          buttonSkip: "Skip User Tour",
          buttonPrevious: "Previous",
          buttonNext: "Next",
          buttonStop: "Finish",
        },
        highlight: true,
      },
      userCallbacks: {
        onSkip: this.handleTourSkipAndFinish,
        onFinish: this.handleTourSkipAndFinish,
      },
      addModalOpen: false,
      editModalOpen: false,
      historyModalOpen: false,
      editModalData: {},
      filtersApplied: filtersAppliedFromStorage,
      deleteConfirmModalOpen: false,
      deleteApprover: null,
      approverEditHistory: [],
      editHistoryError: false,
      userHasNotAccess: false,
      approverManagementConstants: approverManagementConstants,
    };
  },
  computed: {
    pageCount: function () {
      return Math.ceil(this.usersListCount / this.itemsPerPage);
    },
    triggerFetchUsers: function () {
      return [this.activePage, this.triggerUpdate];
    },
    appliedFiltersByRole: function () {
      console.log("Filter applied is : " + this.filtersApplied);
      return this.filtersApplied;
    },
    ...mapGetters(["getIsSupport"]),
  },
  watch: {
    triggerFetchUsers() {
      this.getAllUsers();
    },
    filtersApplied() {
      let clearFilter = true;
      const appliedFiltersByRole = this.appliedFiltersByRole;
      Object.keys(appliedFiltersByRole).forEach((filter) => {
        if (
          (isObject(appliedFiltersByRole[filter]) &&
            !isEmpty(appliedFiltersByRole[filter])) ||
          (typeof appliedFiltersByRole[filter] === "boolean" &&
            appliedFiltersByRole[filter]) ||
          appliedFiltersByRole[filter].length
        ) {
          clearFilter = false;
        }
      });
      this.filterCleared = clearFilter;
      sessionStorage.setItem(
        "userApproverAppliedFilters_v1.1.9",
        JSON.stringify(this.filtersApplied)
      );
    },
  },
  mounted() {
    this.fetchUserAccess();
    this.getAllUsers();
    this.filterCleared = getFilterStatus(this.appliedFiltersByRole);
  },
  methods: {
    async fetchUserAccess() {
      try {
        const {
          idTokenClaims: { oid: id },
        } = this.$store.getters.getTokenData;
        const {
          data: { groupIds: groupIds },
        } = await AxiosFetch(
          userActions.getUserGroupsFromAzure(
            [azureActiveDirectoryGroups.azureAdForApproverAccess],
            this.user.id || id
          )
        );
        if (groupIds) {
          this.userHasNotAccess = !groupIds.includes(
            azureActiveDirectoryGroups.azureAdForApproverAccess
          );
        } else {
          this.userHasNotAccess = true;
        }
      } catch (error) {
        console.error(error);
        const errorData = error?.response?.data?.error || {};
        if (Object.keys(errorData)?.length > 0) {
          showToast("error", errorData.message);
        }
      }
    },
    toggleFilter() {
      this.filterVisible = !this.filterVisible;
    },
    handleFilterChange(options) {
      const { filterName, value, type } = options;
      let filters = { ...this.filtersApplied };
      console.log("Filters Applied:", filters);
      const isFilterPresent = Object.keys(filters);
      // Filter Configuration
      if (type === "checkbox") {
        if (isFilterPresent.includes(filterName)) {
          const index = filters[filterName].indexOf(value);
          index > -1
            ? filters[filterName].splice(index, 1)
            : filters[filterName].push(value);
        } else {
          filters = {
            ...filters,
            [filterName]: [],
          };
          filters[filterName].push(value);
        }
      } else if (type === "dropdown") {
        filters[filterName] = [...value];
      }
      this.filtersApplied = filters;

      this.filtersApplied = filters;
      this.filterCleared = false;
      this.triggerUpdate = new Date();
    },
    generateThumbnail(name) {
      let nameArr = name.split(" ");
      let nameStr = "";
      nameArr.forEach((item) => {
        nameStr += item[0];
      });
      return nameStr.toUpperCase();
    },
    handleSearchChange(event) {
      console.log("inside handleSearchChange");
      const [filterName, searchContent] = event.split(":");
      if (searchContent) {
        let data = this.allconfiguration;
        let foundData = data[filterName].options.filter((item) => {
          const itemInLowerCase = item.value.toLowerCase();
          return itemInLowerCase.includes(searchContent.toLowerCase());
        });
        this.configuration = {
          ...this.configuration,
          [filterName]: {
            ...this.configuration[filterName],
            options: foundData,
          },
        };
      } else {
        this.configuration = this.allconfiguration;
      }
    },
    onRemoveFilter(filterName) {
      let filters = { ...this.filtersApplied };
      delete filters[filterName];
      this.filtersApplied = filters;
      this.filterCleared = isEmpty(filters);
      this.triggerUpdate = new Date();
    },
    onClearFilter() {
      this.filtersApplied = {};
      this.filterCleared = true;
      this.filterVisible = false;
      this.triggerUpdate = new Date();
    },
    handleFilterToggle(event) {
      this.configuration[event].expanded = !this.configuration[event].expanded;
    },
    getAllUsers: async function () {
      this.userLoading = true; // test
      this.userError = false;
      let payload = {
        childRequired: true,
        pageSize: this.itemsPerPage,
        pageOffset: this.activePage * this.itemsPerPage - this.itemsPerPage,
      };
      if (!isEmpty(this.filtersApplied)) {
        payload = {
          ...payload,
          filter: this.formatPayloadFilter(this.filtersApplied),
        };
        console.log("filtered payload :: " + JSON.stringify(payload));
      }

      let requestPayload = userManagament.getApprovers(
        payload,
        `Bearer ${await getMsalIdToken(this)}`
      );
      try {
        const {
          data: { response, totalElement },
        } = await AxiosFetch(requestPayload);
        this.usersList = response;
        this.usersListCount = totalElement || 0;
        this.userLoading = false;
        this.userError = false;
      } catch (err) {
        const errorData = err?.response?.data?.error || {};
        if (Object.keys(errorData)?.length > 0) {
          showToast("error", errorData.message);
        }
        this.userLoading = false;
        this.userError = true;
      }
    },
    formatPayloadFilter(filter) {
      const mappings = {
        User: "userApmId",
        "L1 Apm Id": "l1ApmId",
        "L2 Apm Id": "l2ApmId",
        "Site Leader Apm Id": "siteLeaderApmId",
      };
      const formatted = Object.keys(filter).reduce((acc, key) => {
        const name = mappings[key];
        filter[key].map((item) => {
          if (typeof item == "object") {
            acc.push({ [name]: item.employeeId });
          } else {
            acc.push({ [name]: item });
          }
        });
        return acc;
      }, []);
      return formatted;
    },
    onChangePage(selected) {
      this.activePage = selected;
      scrollWindow();
    },
    handleActionChange(data) {
      const { status, selectedGam } = data;
      this.selectedStatus = status;
      this.actionData = { ...selectedGam };
      this.actionModalOpen = true;
      //this.$modal.show("action-modal");
    },
    handleModalClose({ reload, modalName }) {
      if (modalName === "add-user-modal") {
        this.addModalOpen = false;
      } else if (modalName === "edit-user-modal") {
        this.editModalOpen = false;
      }
      if (reload) {
        this.reloadData();
      }
    },
    onModalClose(name) {
      //this.$modal.hide(name);
    },
    handleTourSkipAndFinish() {
      this.showDashboardTour = false;
    },
    handleAddUser() {
      this.addModalOpen = true;
      // this.$modal.show("add-user-modal");
    },
    handleEditUser(row) {
      this.editModalData = { ...row };
      this.editModalOpen = true;
      this.fetchSingleApprover(row.userApmId);
    },
    async fetchSingleApprover(id) {
      this.userError = false;

      let requestPayload = await userManagament.getSingleApprovers(
        id,
        `Bearer ${await getMsalIdToken(this)}`
      );
      try {
        const response = await AxiosFetch(requestPayload);
        console.log("Edit modal data is :: " + JSON.stringify(response));
        const { data } = response;
        this.editModalData = {
          ...data,
        };
        this.editModalOpen = true;
        //this.$modal.show("edit-user-modal");
        this.userError = false;
      } catch (err) {
        const errorData = err?.response?.data?.error || {};
        if (Object.keys(errorData)?.length > 0) {
          showToast("error", errorData.message);
        }
        this.userLoading = false;
        this.userError = true;
      }
    },
    handlePreDeleteUser(row) {
      this.deleteApprover = { ...row };
      this.deleteConfirmModalOpen = true;
      // this.$modal.show("confirmation-modal");
    },
    handleDeleteUser: async function () {
      const { userApmId, userName } = this.deleteApprover;

      let requestPayload = await userManagament.deleteApprover(
        userApmId,
        `Bearer ${await getMsalIdToken(this)}`
      );
      try {
        await AxiosFetch(requestPayload);
        this.onDeleteConfirmModalClose();
        showToast("success", `${userName} deleted`);
        this.deleteApprover = null;
        this.reloadData();
      } catch (err) {
        console.log("error is " + err.response.data);
        this.onDeleteConfirmModalClose();
        showToast("error", err.response.data);
      }
    },
    onHistoryModalClose() {
      this.onModalClose("history-modal");
    },
    handleApproverModalClose() {
      this.addModalOpen = false;
      this.onModalClose("add-user-modal");
    },
    handleEditApproverModalClose() {
      this.editModalOpen = false;
      //this.onModalClose("edit-user-modal");
    },
    onDeleteConfirmModalClose() {
      this.deleteConfirmModalOpen = false;
      this.onModalClose("confirmation-modal");
    },
    async handleCreateUser(payload) {
      let requestPayload = userManagament.createApprover(
        payload,
        `Bearer ${await getMsalIdToken(this)}`
      );
      try {
        await AxiosFetch(requestPayload);
        showToast("success", `User Profile created for ${payload.userName}`);
        this.handleModalClose({ reload: true, modalName: "add-user-modal" });
      } catch (error) {
        if (error.response) {
          const { status } = error.response;
          if (status === 409 || status === 400) {
            showToast(
              "error",
              "Duplicate User. Please try with different user."
            );
          }
        } else {
          console.log(error.message);
        }
        this.$refs.approverCreateModal.resetProcessButton();
      }
    },
    async handleUpdateUser(payload) {
      console.log("Payload is ::" + JSON.stringify(payload));
      let newpayload = {
        l1ApmId: payload.l1ApmId,
        l2ApmId: payload.l2ApmId,
        siteLeaderApmId: payload.siteLeaderApmId,
        skills: payload.skills,
        lineOfBusiness: payload.lineOfBusiness,
        assignedCarrierCode: payload.assignedCarrierCode,
        assignedCountryCode: payload.assignedCountryCode,
        tenderApplicable: payload.tenderApplicable,
        gsc: payload.gsc,
        roles: payload.roles,
      };
      let requestPayload = await userManagament.updateApprover(
        payload.userApmId,
        newpayload,
        `Bearer ${await getMsalIdToken(this)}`
      );
      try {
        await AxiosFetch(requestPayload);
        showToast("success", `User Profile Updated for ${payload.userName}`);
        this.handleModalClose({ reload: true, modalName: "edit-user-modal" });
      } catch (error) {
        if (error.response) {
          const errorData = error?.response?.data?.error || {};
          if (Object.keys(errorData)?.length > 0) {
            showToast("error", errorData.message);
          }
        } else {
          console.log(error.message);
        }
        this.$refs.approverEditModal.resetProcessButton();
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
// Styles Imports
@import "@/styles/imports";

#user-profile {
  display: flex;
  flex: 1;
  min-height: calc(100vh - 134px);
  max-width: 1280px;
  margin: 0 auto;
  margin-top: 86px;
  padding: 24px;

  & .filter-area {
    width: 237px;
    display: flex;
    &-title {
      color: #000000;
      font-size: 18px;
      font-family: "Maersk Headline Light";
      margin: 0 0 24px;
    }
  }
  @include media("<=desktop") {
    padding: 16px;

    & .filter-area {
      display: none;
      &.visible {
        display: flex;
        position: fixed;
        z-index: 9999;
        left: 0;
        top: 0;
        bottom: 0;
        background: #ffffff;
        overflow: auto;
        width: 100%;
        & .filter {
          width: 100%;
        }
      }
    }
  }
  & .content-area {
    margin-left: 24px;
    display: flex;
    flex: 1;
    flex-direction: column;

    &.scrollable {
      width: 100%;
      max-width: calc(1280px - 330px);
      @include media("<=desktop") {
        max-width: calc(100vw - 75px);
      }
      @include media("<=768px") {
        max-width: calc(100vw - 35px);
      }
    }

    & .tab-area {
      display: flex;
      justify-content: space-between;
    }

    & .tabbar {
      flex-direction: row;
      justify-content: space-between;
      display: flex;
      align-items: center;
    }
    @include media("<=tablet") {
      margin-left: 0;

      & .tabbar {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 24px;
      }
    }

    & > h4 {
      color: #000000;
    }

    & .error-message {
      & ul {
        padding-left: 40px;
        & li {
          font-family: "Maersk Text Light";
          list-style: disc;
        }
      }
    }

    & .title-area {
      display: flex;
      justify-content: space-between;
      align-items: center;
      & > .title {
        font-size: 18px;
        font-family: "Maersk Headline Bold";
        color: #0073ab;
        margin-bottom: 8px;
        margin-top: 0;
      }
      & .filter-button {
        display: none;
        @include media("<=desktop") {
          font-family: "Maersk Headline";
          align-items: center;
          display: flex;
          background-color: var(--card-bg);
          box-shadow: 0px 1px 2px var(--shadow-color);
          padding: 4px 8px;
          cursor: pointer;

          & > span {
            font-size: 16px;
            color: #000000;
            margin-right: 8px;
          }
          & > div {
            display: flex;
            border-radius: 4px;
            & > svg {
              fill: #00243d;
            }
          }
        }
      }
    }
  }
}

.grid-cards {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;

  h4 {
    font-size: 18px;
    font-family: "Maersk Headline Bold";
    color: #000000;
  }
}

.toggle-area {
  display: flex;
  align-items: center;
  & span {
    font-family: "Maersk Headline";
    font-size: 14px;
    margin-left: 12px;
    margin-right: 12px;
    color: #000000;
  }
}

.tour-content {
  background-color: #ededed;
  color: #000000;

  [data-tour-elem="left-arrow"] {
    color: #ffffff;
    &[disabled] {
      color: rgba(0, 0, 0, 0.4);
    }
  }

  [data-tour-elem="right-arrow"] {
    color: #0073ab;
    &[disabled] {
      color: rgba(0, 0, 0, 0.4);
    }
  }
}

.approver-management-empty-state {
  margin-top: 24px;
  & h4 {
    font-size: 18px;
    color: #000000;
    font-family: "Maersk Headline Light";
  }
  & img {
    width: 350px;
  }
}

.actions-container {
  display: flex;
  margin-top: 0.5rem;
  .btn-container {
    display: flex;
    flex: 1;
    justify-content: flex-end;
  }
}
.add-user-button {
  flex: none;
}
</style>
  <style>
.search-box {
  width: 240px;
}
</style>
  